<template>
  <div class="container my-4">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="fw-bold">Manage Components</h2>
      <button @click="showAddComponentModal = true" class="btn btn-primary">
        <i class="bi bi-plus-circle me-2"></i>Add New Component
      </button>
    </div>

    <!-- Component List -->
    <div class="row">
      <div
          class="col-md-4 col-sm-6 mb-4"
          v-for="(component, index) in components"
          :key="index"
      >
        <div class="card shadow-sm h-100">
          <img
              :src="component.previewImage"
              class="card-img-top"
              :alt="component.name"
              style="height: 150px; object-fit: cover;"
          />
          <div class="card-body text-center">
            <h5 class="card-title">{{ component.name }}</h5>
            <p class="text-muted">{{ component.type }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Add Component Modal -->
    <div
        class="modal fade"
        :class="{ show: showAddComponentModal }"
        tabindex="-1"
        style="display: block"
        role="dialog"
        v-if="showAddComponentModal"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add New Component</h5>
            <button
                type="button"
                class="btn-close"
                aria-label="Close"
                @click="closeModal"
            ></button>
          </div>
          <div class="modal-body">
            <form @submit.prevent="submitComponent">
              <div class="mb-3">
                <label for="componentName" class="form-label">Component Name</label>
                <input
                    type="text"
                    v-model="newComponent.name"
                    class="form-control"
                    id="componentName"
                    placeholder="Enter component name"
                    required
                />
              </div>

              <div class="mb-3">
                <label for="componentType" class="form-label">Component Type</label>
                <select
                    v-model="newComponent.type"
                    class="form-select"
                    id="componentType"
                    required
                >
                  <option value="" disabled>Select component type</option>
                  <option value="text">Text</option>
                  <option value="image">Image</option>
                  <option value="video">Video</option>
                  <!-- Add more options as needed -->
                </select>
              </div>

              <div class="mb-3">
                <label for="propsSchema" class="form-label">Props Schema (JSON)</label>
                <textarea
                    v-model="newComponent.props_schema"
                    class="form-control"
                    id="propsSchema"
                    rows="4"
                    placeholder='{"propName": {"type": "string", "default": ""}}'
                    required
                ></textarea>
                <button
                    type="button"
                    class="btn btn-secondary mt-2"
                    @click="beautifyJson"
                >
                  Beautify JSON
                </button>
              </div>

              <div class="mb-3">
                <label for="previewImage" class="form-label">Preview Image</label>
                <input
                    type="file"
                    @change="handleFileUpload"
                    class="form-control"
                    id="previewImage"
                />
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" @click="closeModal">Close</button>
                <button type="submit" class="btn btn-primary">Add Component</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <!--      <div class="modal-backdrop fade show"></div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentView',
  data() {
    return {
      showAddComponentModal: false,
      newComponent: {
        name: '',
        type: '',
        props_schema: '',
        preview_image: null,
      },
      components: [],
    };
  },
  created() {
    this.fetchPages();
  },
  methods: {
    handleFileUpload(event) {
      this.newComponent.preview_image = event.target.files[0];
    },
    async fetchPages() {
      try {
        const response = await fetch('/dashboard/components/'); // Replace with your actual Django endpoint
        const data = await response.json();
        this.components = data;
      } catch (error) {
        console.error('Failed to fetch components:', error);
      }
    },
    beautifyJson() {
      try {
        const parsedJson = JSON.parse(this.newComponent.props_schema);
        this.newComponent.props_schema = JSON.stringify(parsedJson, null, 2);
      } catch (e) {
        alert('Invalid JSON format. Please correct it and try again.');
      }
    },
    submitComponent() {
      const formData = new FormData();
      formData.append('name', this.newComponent.name);
      formData.append('type', this.newComponent.type);
      formData.append('props_schema', this.newComponent.props_schema);
      if (this.newComponent.preview_image) {
        formData.append('preview_image', this.newComponent.preview_image);
      }

      fetch('/dashboard/save-component/', {
        method: 'POST',
        body: formData,
      })
          .then(response => {
            if (!response.ok) {
              throw new Error('Failed to save the component.');
            }
            return response.json();
          })
          .then(data => {

            console.log(data)
            this.closeModal();

            // Refresh the component list (re-render)
            this.fetchPages();
          })
          .catch(error => {
            console.error(error);
            alert('Failed to save the component.');
          });
    },
    closeModal() {
      this.showAddComponentModal = false;
      this.newComponent = {name: '', image: ''};
    },

  },
};
</script>

<style scoped>
.card {
  transition: transform 0.2s;
}

.card:hover {
  transform: translateY(-5px);
}

.card-img-top {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

h2.fw-bold {
  color: #343a40;
}

.modal.fade {
  display: none;
}

.modal.show {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-backdrop {
  z-index: 1040;
}
</style>
